import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import UserService from 'services/user-service';
import { FetchStatus, ResultState } from 'types/common';
import { RootState } from './index';

const initialState: ResultState<string | null> = {
	data: null,
	status: FetchStatus.IDLE,
	error: null,
};

export const fetchUserReferralLinkAsync = createAsyncThunk(
	'users/referral-link',
	async () => {
		const response = await UserService.getReferralLink();

		return response.link;
	},
);

export const userReferralLinkSlice = createSlice({
	name: 'userReferralLink',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchUserReferralLinkAsync.pending, (state) => {
				state.status = FetchStatus.LOADING;
			})
			.addCase(fetchUserReferralLinkAsync.fulfilled, (state, action) => {
				state.status = FetchStatus.IDLE;
				state.data = action.payload;
			});
	},
});

const getUserReferralLink = (state: RootState) => state.userReferralLink;

export const getUsersReferralLinkData = createSelector(getUserReferralLink, link => link.data);

export default userReferralLinkSlice.reducer;
